import { useNavigate } from "react-router";

import PageHeader from "../../components/PageHeader";
import Card from "../../components/Card";
import InvoiceComponent from "../../components/Invoice";
import Button from "../../base-components/Button";
import { ReactComponent as Check } from "../../assets/icons/check-circle-2-1.svg";

const Invoice = () => {
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader title="Нэхэмжлэх дүн" backTo="/result" />
      <Card>
        <InvoiceComponent />
      </Card>
      <div className="mt-4">
        <Button
          icon={<Check fill="#fff" className="w-[18px] h-[18px]" />}
          onClick={() => navigate("/thank-you")}
          textSize="md"
          className="w-full"
        >
          Дуусгах
        </Button>
      </div>
    </div>
  );
};

export default Invoice;
